import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Sprint 2.4 (Enterprise Design System Foundation): no breadcrumb component existed anywhere in the
// app before this. `items` is an array of {label, path?} — the last item (or any item without a path)
// renders as plain, non-clickable current-page text.
const Breadcrumb = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className="ent-breadcrumb" aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={item.label + index}>
            {item.path && !isLast ? (
              <Link to={item.path} className="ent-breadcrumb-item">{item.label}</Link>
            ) : (
              <span className="ent-breadcrumb-item is-current" aria-current={isLast ? 'page' : undefined}>{item.label}</span>
            )}
            {!isLast && <span className="ent-breadcrumb-separator" aria-hidden="true">/</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.string
  }))
};

export default Breadcrumb;
